import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { Inquiry } from '@models/contact';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ContactService {
    private domain: string;

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    postInquiry(inquiry: Inquiry) {
        const header = new HttpHeaders({ 'Content-Type': 'application/json' });
        this.http
            .post<any>(this.domain + '/api/contact/purchaseinquiry', inquiry, {
                headers: header,
            })
            .subscribe(res => {});
    }

    async sendErrorReport(receiverAddress) {
        const header = new HttpHeaders({ 'Content-Type': 'application/json' });
        await lastValueFrom(
            this.http.post(
                `${this.domain}/api/contact/error-report`,
                { receiverAddress },
                {
                    headers: header,
                }
            )
        );
    }
}
